
<h1 class="text-center" style="padding-top:25px; font-weight: 600;"> EDIT &nbsp; PROFILE  </h1>
<div class="container" >
    <form role="form">
        <div class=" container pl-2">
            <div class="form-group col-md-12">
                <div class="row">
                    <div class="col-md-6">
                        <fa-icon [icon]="faUserCircle" class="fa-6x"></fa-icon>
                    </div>
                    <div class="col-md-6">
                        <input type="file" class="upload_box" accept="image/*">
                    </div>    
                </div> 
            </div>  
        </div>
        <div class="container fieldset pt-1">
            <h2 class="mt-4 mb-3"> PERSONAL DETAILS : </h2>
            <div class="row">
                <div class="form-group col-md-6">
                    <input class="form-control" name="username" placeholder=" Name *" type="text" [ngModel]="user.name" (ngModelChange)="onNameChange($event)">              
                </div>
                <div class="form-group col-md-6">
                    <input class="form-control" name="email" placeholder="Email *" type="email" [ngModel]="user.email" (ngModelChange)="onChangeEmail($event)">
                </div>
            </div>
        
            <div class="row">
                <div class="form-group col-md-6">
                    <input class="form-control" name="phone" placeholder="Phone Number *" type="text" minlength="10" [ngModel]="user.phone" (ngModelChange)="onChangePhone($event)" >
                </div>
                <div class="form-group col-md-6">
                    <input class="form-control" name="emergencycontact" placeholder="Emergency Contact *" type="text" [ngModel]="user.emergencycontact" (ngModelChange)="onChangeEmergencyContact($event)">
                </div>
            </div>

            <div class="row">
                <div class="form-group col-md-6">
                    <input class="form-control" name="father_name" placeholder="Father's Name *" type="text" minlength="6" [ngModel]="user.father_name" (ngModelChange)="onChangeFatherName($event)" >
                </div>
                <div class="form-group col-md-6">
                    <input class="form-control" name="mother_name" placeholder="Mother's Name *" type="text" minlength="6" [ngModel]="user.mother_name" (ngModelChange)="onChangeMotherName($event)" >
                </div>
            </div>

            <div class="row">
                <div class="form-group col-md-6">
                    <input class="form-control" name="addressl1" placeholder="Address Home *" type="text" minlength="10" [ngModel]="user.addressl1" (ngModelChange)="onChangeAddress($event)" >
                </div>
                <div class="form-group col-md-6">
                    <input class="form-control" name="state" placeholder="State Name *" type="text" [ngModel]="user.state" (ngModelChange)="onChangeState($event)" >
                </div>
            </div>
            <div class="row">
                <div class="form-group col-md-6">
                    <input class="form-control" name="zipcode" placeholder="Zipcode For Home Address *" type="text" minlength="5" [ngModel]="user.zipcode" (ngModelChange)="onChangeZipcode($event)" >
                </div>
                <div class="form-group col-md-6">
                    <select class="form-control" name="cityType" name="city" [ngModel]="user.city" (ngModelChange)="onChangeCity($event)">
                        <option value="city" disabled> City </option>
                        <option *ngFor="let x of citySel" [ngValue]="x.id">{{x.text}} </option>
                    </select> 
                </div> 
            </div>
            <div class="row">
                <div class="form-group col-md-6">
                    <select class="form-control" name="genType" name="gender" [ngModel]="user.gender" (ngModelChange)="onGenderChange($event)">
                        <option value="gender" disabled> Gender </option>
                        <option *ngFor="let x of genderSeluser" [ngValue]="x.id">{{x.text}} </option>
                    </select> 
                </div> 

                <div class="form-group col-md-6">
                    <input type="date" name="dob" [min]="minDOB" [max]="maxDOB" [ngModel]="user.dob" class="form-control" placeholder="DOB" (ngModelChange)="onDOBChange($event)">
                </div>
            </div>
        </div>
        <div class="container fieldset pt-1 mt-4">
            <h2 class="mt-4 mb-3"> PROFESSIONAL DETAILS : </h2>
            <div class="row">
                <div class="form-group col-md-6">
                    <input class="form-control" name="occupation" placeholder="Occupation " type="text" minlength="10" [ngModel]="user.occupation" (ngModelChange)="onChangeOccupation($event)" >
                </div>
                <div class="form-group col-md-6">
                    <input class="form-control" name="nationality" placeholder="Nationality *" type="text" minlength="5" [ngModel]="user.nationality" (ngModelChange)="onChangeNationality($event)" >
                </div>
            </div>
        
            <div class="row">
                <div class="form-group col-md-6">
                    <input class="form-control" name="adhaar_number" placeholder="Adhaar Number *" type="text" minlength="10" [ngModel]="user.adhaar_number" (ngModelChange)="onChangeAdharNumber($event)" >
                </div>
                <div class="form-group col-md-6">
                    <input class="form-control" name="pan" placeholder="PAN *" type="text" minlength="6" [ngModel]="user.pan" (ngModelChange)="onChangePan($event)" >
                </div>
            </div>

            <div class="row">
                <div class="form-group col-md-6">
                    <input class="form-control" name="off_name" placeholder="Company / Office Name" type="text" minlength="12" [ngModel]="user.off_name" (ngModelChange)="onChangeOffName($event)" >
                </div>
                <div class="form-group col-md-6">
                    <input class="form-control" name="off_email" placeholder="Office Email" type="text" minlength="5" [ngModel]="user.off_email" (ngModelChange)="onChangeOffEmail($event)" >
                </div>
            </div>

            <div class="row">
                <div class="form-group col-md-6">
                    <input class="form-control" name="off_address" placeholder="Office Address" type="text" minlength="5" [ngModel]="user.off_address" (ngModelChange)="onChangeOffAddress($event)" >
                </div>
                <div class="form-group col-md-6">
                    <input class="form-control" name="off_city" placeholder="Office City" type="text" minlength="5" [ngModel]="user.off_city" (ngModelChange)="onChangeOffCity($event)" >
                </div>
            </div>

            <div class="row">
                <div class="form-group col-md-6">
                    <input class="form-control" name="off_state" placeholder="Office State" type="text" minlength="12" [ngModel]="user.off_state" (ngModelChange)="onChangeOffState($event)" >
                </div>
                <div class="form-group col-md-6">
                    <input class="form-control" name="off_country" placeholder="Office Country" type="text" minlength="12" [ngModel]="user.off_country" (ngModelChange)="onChangeOffCountry($event)" >
                </div>
            </div>
            <div class="row">
                <div class="form-group col-md-6">
                    <input class="form-control" name="off_zipcode" placeholder="Office Zipcode" type="text" minlength="12" [ngModel]="user.off_zipcode" (ngModelChange)="onChangeOffZipcode($event)" >
                </div>
                <div class="form-group col-md-6">
                </div> 
            </div>
        </div>
        <div class="container fieldset pt-1 mt-4">
            <div class="row">
                <div class="form-group col-md-12">
                    <h2 class="mt-4 mb-3">BANK DETAILS :</h2>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-md-6">
                    <input class="form-control" name="bank_ifsc" placeholder="Bank IFSC" type="text" minlength="6" required  [ngModel]="user.bank_ifsc" (ngModelChange)="onChangeBankIfsc($event)" >
                </div>
                <div class="form-group col-md-6">
                    <input class="form-control" name="bank_account" placeholder="Bank Account" type="text" minlength="10" required [ngModel]="user.bank_account" (ngModelChange)="onChangeBankAccount($event)" >
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row mt-4">
                <div  class="form-group col-md-4">
                    <p> All the Fields marked with * are mandatory </p>
                </div>
            </div>
        </div> 
        <div style="display: flex; justify-content: center;">
            <button type="submit" class="btn btn-success" (click)="editProfile()">Submit </button>
        </div>
    </form>     
</div>
 
<div class="form_sub_msg" *ngIf="form_msg == true">
    <p> {{ form_submit_msg }} </p>
</div>
<div class="form_pass_msgs" *ngIf="form_success_msg == true">
    <p> {{ form_submit_msg }} </p>
</div>
